import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { Link } from "react-router-dom";
import { ScanBarcode } from "lucide-react";
import BaseInput from "@reusables/BaseInput";
import { SaleOrdersFormTyping } from "@components/Dashboard/pages/Sales/Orders/components/MutationLayout/types";
import { useTranslation } from "react-i18next";

export default function OrderReference() {
    const { t } = useTranslation("", { keyPrefix: "sales.orders" });
    const { control } = useFormContext<SaleOrdersFormTyping>();
    const [referenceNumberElement, setReferenceNumberElement] = useState<HTMLElement | null>(
        null
    );

    const referenceNumberId = useWatch({
        control,
        name: "reference_number.id",
    });

    useEffect(() => {
        setReferenceNumberElement(document.getElementById("reference_number"));
    }, []);

    const icon = (
        <>
            {referenceNumberId ? (
                <Link to={`/dashboard/purchasing/${referenceNumberId}/details`}>
                    <ScanBarcode color={"#a0a0a0"} />
                </Link>
            ) : (
                <ScanBarcode color={"#a0a0a0"} />
            )}
        </>
    );

    return (
        <>
            {referenceNumberElement &&
                createPortal(
                    <Controller
                        control={control}
                        name={"reference_number.code"}
                        render={({ field, fieldState }) => (
                            <BaseInput
                                {...field}
                                error={fieldState.error}
                                placeholder={t("general.fields.reference.label")}
                                icon={{
                                    right: {
                                        el: icon,
                                        offset: "12px",
                                    },
                                }}
                            />
                        )}
                    />,
                    referenceNumberElement
                )}
        </>
    );
}
